// import DarkModeIcon from '@mui/icons-material/DarkMode'; 
// import LightModeIcon from '@mui/icons-material/LightMode';
// import ButtonIcon from "./ButtonIcon";
// import { useDarkMode } from "../../context/DarkModeContext";

function DarkModeToggle() {

  // const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <>
    {/* <ButtonIcon onClick={toggleDarkMode}>
      {isDarkMode ? <LightModeIcon sx={{ fill: '#fff' }}  /> : <DarkModeIcon sx={{fill:'#000'}} />}
    </ButtonIcon> */}
    </>
  );
}

export default DarkModeToggle;
